import { render, staticRenderFns } from "./formWriteGroupLabelInput.vue?vue&type=template&id=5465e8de&"
import script from "./formWriteGroupLabelInput.vue?vue&type=script&lang=js&"
export * from "./formWriteGroupLabelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5465e8de')) {
      api.createRecord('5465e8de', component.options)
    } else {
      api.reload('5465e8de', component.options)
    }
    module.hot.accept("./formWriteGroupLabelInput.vue?vue&type=template&id=5465e8de&", function () {
      api.rerender('5465e8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/formWriteGroupLabelInput.vue"
export default component.exports